import { FC } from 'react';
import { BackendClient } from '@/infrastructure/clients/BackendClient';
import LureoButton from '@/common/LureoButton';

interface AppleAuthButtonProps {
  onError: (message: string) => void;
  marketingConsent?: boolean;
  canStart?: () => boolean;
}

export const AppleAuthButton: FC<AppleAuthButtonProps> = ({ onError, marketingConsent, canStart }) => {

  const handleAppleSignIn = async () => {
    if (canStart && !canStart()) return;
    try {
      // Always use current origin as redirect URL - this ensures it matches the current environment
      // Supabase will validate this against the allowed redirect URLs in the project settings
      const redirectUrl = window.location.origin;

      const { data, error } = await BackendClient.auth.signInWithOAuth({
        provider: 'apple',
        marketingConsent,
        options: {
          redirectTo: redirectUrl,
        }
      });

      if (error) {
        onError(error.message);
        return;
      }

      if (data.url) {
        // Redirect to Apple's OAuth page
        window.location.href = data.url;
      }
    } catch {
      onError('Failed to connect to Apple authentication');
    }
  };

  return (
    <LureoButton
      onClick={handleAppleSignIn}
      variant="outline-3"
      className="w-full h-9 rounded-lureo-radius-button-pill"
    >
      <span className="flex items-center justify-center gap-2">
        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M16.365 1.43c0 1.14-.417 2.2-1.25 3.06-.83.86-1.92 1.5-3.04 1.4-.13-1.1.42-2.28 1.2-3.05.82-.83 2.04-1.45 3.09-1.41zM20.5 17.1c-.55 1.27-.82 1.84-1.53 2.97-1 1.57-2.41 3.53-4.16 3.54-1.56.02-1.96-1.02-4.07-1-2.11.01-2.55 1.02-4.11 1-1.75-.02-3.09-1.79-4.09-3.36C-.4 17.4-.7 12.07 1.06 9.27c.99-1.6 2.6-2.61 4.33-2.64 1.6-.03 3.1 1.08 4.07 1.08.97 0 2.8-1.33 4.72-1.13.8.03 3.06.32 4.51 2.44-.12.07-2.69 1.57-2.66 4.69.03 3.72 3.25 4.96 3.29 4.98z"/>
        </svg>
        Continue with Apple
      </span>
    </LureoButton>
  );
};
